var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{ref:"dropdownMenu",staticClass:"dropdown menu vertical block",class:[_vm.placement && `dropdown--${_vm.placement}`],staticStyle:{"z-index":"11"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }